export const GET_JIRA_ISSUES = 'GET_JIRA_ISSUES';
export const GET_JIRA_ISSUES_LOADING = 'GET_JIRA_ISSUES_LOADING';
export const GET_JIRA_ISSUE = 'GET_JIRA_ISSUE';
export const GET_JIRA_ISSUE_LOADING = 'GET_JIRA_ISSUE_LOADING';
export const GET_JIRA_ISSUE_ATTACHMENTS = 'GET_JIRA_ISSUE_ATTACHMENTS';
export const GET_JIRA_ISSUE_ATTACHMENTS_LOADING = 'GET_JIRA_ISSUE_ATTACHMENTS_LOADING';
export const GET_JIRA_ISSUE_COMMENTS = 'GET_JIRA_ISSUE_COMMENTS';
export const GET_JIRA_ISSUE_COMMENTS_LOADING = 'GET_JIRA_ISSUE_COMMENTS_LOADING';

export default {
  GET_JIRA_ISSUES,
  GET_JIRA_ISSUES_LOADING,
  GET_JIRA_ISSUE,
  GET_JIRA_ISSUE_LOADING,
  GET_JIRA_ISSUE_ATTACHMENTS,
  GET_JIRA_ISSUE_ATTACHMENTS_LOADING,
  GET_JIRA_ISSUE_COMMENTS,
  GET_JIRA_ISSUE_COMMENTS_LOADING,
};
